import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ReactPlayer from 'react-player';

const moodData = {
  sad: {
    emoji: '🥲',
    quote: 'Every storm runs out of rain.',
    videoSrc: 'https://youtu.be/H1frBzuWqqM?si=5tw0ygW-jD-oHPWc',
  },
  evil: {
    emoji: '👿',
    quote: 'Sometimes you gotta be bad to do good.',
    videoSrc: 'https://youtu.be/nuKXEb-K24Q?si=W_V_8nYJhaKQeYdg',
  },
  annoyed: {
    emoji: '😒',
    quote: 'Patience is the key to joy.',
    videoSrc: 'https://youtu.be/P-jKtzUuVcM?si=SeyUAYbXx9Z-diDo',
  },
  happy: {
    emoji: '🥰',
    quote: 'Happiness is a journey, not a destination.',
    videoSrc: 'https://youtu.be/rxp_zOtY-IA?si=oii68MGUV1EnDzk7',
  },
  love: {
    emoji: '😘',
    quote: 'Love is the bridge between you and everything.',
    videoSrc: 'https://youtu.be/U1JLtpJTe84?si=oVWM4-9i-3ZJlZ_7',
  },
  angry: {
    emoji: '😡',
    quote: 'Anger is one letter short of danger.',
    videoSrc: 'https://youtu.be/ckwRhLE9_LY?si=MCAAgDybBMH8jMfE',
  },
};

export default function MoodScreen() {
  const { moodKey } = useParams();
  const navigate = useNavigate();
  const mood = moodData[moodKey] || moodData.happy;

  return (
    <div style={styles.container}>
      <button onClick={() => navigate(-1)} style={styles.backButton}>
        ← Back
      </button>

      <div style={styles.emoji} aria-label="Selected Mood Emoji">
        {mood.emoji}
      </div>

      <h2 style={styles.quote}>{mood.quote}</h2>

      <div style={styles.playerWrapper}>
        <ReactPlayer
          url={mood.videoSrc}
          playing
          muted
          loop
          controls
          width="100%"
          height="100%"
          style={styles.player}
        />
      </div>
    </div>
  );
}

const styles = {
  container: {
    maxWidth: 800,
    margin: 'auto',
    padding: 20,
    textAlign: 'center',
  },
  backButton: {
    marginBottom: 20,
    cursor: 'pointer',
    fontSize: 16,
    padding: '6px 12px',
  },
  emoji: {
    fontSize: 80,
    marginBottom: 10,
  },
  quote: {
    fontSize: 24,
    marginBottom: 20,
    fontStyle: 'italic',
  },
  playerWrapper: {
    position: 'relative',
    paddingTop: '56.25%', // 16:9 aspect ratio
    borderRadius: 12,
    overflow: 'hidden',
    boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
  },
  player: {
    position: 'absolute',
    top: 0,
    left: 0,
  },
};
